var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupHistoryFlowLinesHori(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 12,
    viewBox: "0 0 26 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_32252",
    "data-name": "Group 32252",
    transform: "translate(-1026 -432.5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_2864",
    "data-name": "Ellipse 2864",
    transform: "translate(1040 432.5)",
    fill: "none",
    stroke: "#14b7dd",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 6,
    r: 5.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_3267",
    "data-name": "Line 3267",
    x1: 14,
    transform: "translate(1026.5 439)",
    fill: "none",
    stroke: "#14b7dd",
    strokeLinecap: "round",
    strokeWidth: 1,
    strokeDasharray: "2 2"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupHistoryFlowLinesHori);
export default __webpack_public_path__ + "static/media/GroupHistoryFlowLinesHori.b5907fee592299960d1e52ab035e497b.svg";
export { ForwardRef as ReactComponent };